import { UtilityBar } from "@/components/organisms/UtilityBar";

export function TransactionsSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
